import { gql } from '@apollo/client';

export const PUBNUB_PLACE_UPDATED = gql`
  mutation PubNubPlaceUpdated {
    PubNubPlaceUpdated @client
  }
`;
